import React from "react";
import PropTypes from "prop-types";
import "../../styles/Drawer.scss";
const Drawer = (props) => {
    const { closeDrawer, children, isOpenedDrawer } = props;

    const handleDrawerStyle = () => {
        if (isOpenedDrawer) {
            document.getElementById("sideNav").style.width = "100%";
            document.body.style.overflow = "hidden";
            return;
        }
        document.getElementById("sideNav").style.width = "0px";
        document.getElementById("sideNavbar").style.width = '0px';
        document.getElementById("sideNavbar").style.padding = '0px';
        document.body.style.overflow = "auto";
        return;
    }

    React.useEffect(() => {
        handleDrawerStyle();
        // handleDrawerStyle only depends on isOpenedDrawer (already in deps); function reference would re-trigger unnecessarily.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpenedDrawer]);

    const handleCLosedDrawer = () => {
        document.body.style.overflow = "auto";
        closeDrawer();
    }

    return (
        <div data-testid="mySideNav" className="side-nav" id="sideNav">
            <div className="side-navbar" id="sideNavbar" >
                <div className="close-icon">
                    <i data-testid="closed-icon-id" className="fa fa-times fa fa-2x cursor-pointer" onClick={handleCLosedDrawer} />
                </div>
                <div className="drawer-container">
                    {children}
                </div>
            </div>
        </div>
    )
};

Drawer.propTypes = {
    children: PropTypes.element,
    isOpenedDrawer: PropTypes.bool,
    closeDrawer: PropTypes.func
}

export default Drawer;